export const menu = [

    // ----------------------------------------------------------------------------------------

    {
        type: 'item',
        name: 'ui-workspace-menu-item',
        label: 'Workspace',
        routes: ['workspace-home'],
        privileges: ['adminProjects', 'manageProjects', 'editProjects', 'readProjects']
    },

    // ----------------------------------------------------------------------------------------

    {
        type: 'item',
        name: 'ui-file-repository',
        label: 'Úložiště souborů',
        icon: 'folder-open',
        parent: null,
        routes: ['file-repository', 'file-repository-folder'],
        privileges: [['openFileRepository', 'useFileRepository'], ['openFileRepository', 'adminFileRepository']],
    },

    // ----------------------------------------------------------------------------------------

    {
        type: 'group',
        name: 'ui-test-group-menu-item',
        label: 'Test',
        icon: 'flask-gear',
        parent: null,
        routes: [],
        privileges: ['#admin'],
    },
    {
        type: 'item',
        name: 'ui-test-api-menu-item',
        label: 'API Test',
        parent: 'ui-test-group-menu-item',
        routes: ['test-page'],
        privileges: ['#admin'],
    },
    {
        type: 'item',
        name: 'ui-test-css-typography-menu-item',
        label: 'CSS Typography',
        parent: 'ui-test-group-menu-item',
        routes: ['test-css-typography'],
        privileges: ['#admin'],
    },
    {
        type: 'item',
        name: 'ui-test-css-grid-menu-item',
        label: 'CSS Grid',
        parent: 'ui-test-group-menu-item',
        routes: ['test-css-grid'],
        privileges: ['#admin'],
    },
    {
        type: 'item',
        name: 'ui-test-css-inputs-menu-item',
        label: 'CSS Inputs',
        parent: 'ui-test-group-menu-item',
        routes: ['test-css-inputs'],
        privileges: ['#admin'],
    },
    {
        type: 'item',
        name: 'ui-test-css-helpers-menu-item',
        label: 'CSS Helpers',
        parent: 'ui-test-group-menu-item',
        routes: ['test-css-helpers'],
        privileges: ['#admin'],
    },
    {
        type: 'item',
        name: 'ui-test-controls-menu-item',
        label: 'Controls',
        parent: 'ui-test-group-menu-item',
        routes: ['test-controls'],
        privileges: ['#admin'],
    },

    // ----------------------------------------------------------------------------------------

    {
        type: 'group',
        name: 'administration-menu-item',
        label: 'Administrace',
        icon: 'folder-gear',
        parent: null,
        routes: [],
    },

];
